
<template>
   <div>
        <div id="tooltip-target-1" class="icon-stack set_favorite fs-xxl cursor-pointer" v-on:click="set_favorite()">
            <i :class="{'color-danger-100' : is_favorite, 'color-white' : !is_favorite}" class="fas  fa-star icon-stack-1x " ></i>
        </div>
        
        <b-tooltip target="tooltip-target-1" triggers="hover">
            {{msg}}
        </b-tooltip>
   </div>
</template>


<script >

import {mapGetters} from "vuex";

export default {
    name: "mem_favorite",
    
    methods : {
        async set_favorite() {
            await api.patch('/memorandums/'+ this.mem_id +'/favorite').then(({data}) => {
                if(data.status == "operation_success") {
                    EventBus.$emit("reload_mem",{"mem_id" : this.mem_id});
                }
                
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
            });
        }
    },
    
    computed: {
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load': "memorandum_inside/is_load"
        }),
        
        
        mem_id () {
            return this.memorandum.id;
        },
        
        is_favorite() {
            if(this.memorandum.hasOwnProperty("is_favorite")) {
                return this.memorandum.is_favorite;
            }
            
            return false;
        },
        
        msg: function () {
            if(this.is_favorite) {
                return 'Видалити з обраних';
            }
            
            return 'Додати в обрані';
        }
    }
}
</script>

<style scoped>

</style>